import wrapWithProvider from "./src/components/WPLiveGatsby/wrap-with-provider"
export const wrapRootElement = wrapWithProvider
